import getBeautyList from "./getBeautyList";
import getBeauty from "./getBeauty";

export default { getBeautyList, getBeauty };
